import { Component, Inject, SecurityContext } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { DocumentUploadResponse } from '../shared/models/document-upload-response';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CustomSnackbarData } from '../shared/models/custom-snackbar-data';

@Component({
  selector: 'xp-custom-snackbar',
  templateUrl: './custom-snackbar.component.html',
  styleUrl: './custom-snackbar.component.scss'
})
export class CustomSnackbarComponent {
    constructor(
        @Inject(MAT_SNACK_BAR_DATA) public data: CustomSnackbarData,
        public snackBarRef: MatSnackBarRef<CustomSnackbarComponent>,
        private sanitizer: DomSanitizer
    ) {
    }

    openLink() {
        window.open(this.data.link, '_blank')

        this.snackBarRef.dismiss();
    }

    closeSnackbar(event: Event): void {
        event.preventDefault(); 
        this.snackBarRef.dismiss();
    }
}
